import React , { useState, forwardRef } from 'react';
import Grid from '@mui/material/Grid';
import TextInput from './TextInput';
// import SelectInput from './SelectInput';
import SelectInput from './SelectInput_org';
import styles from './styles';
import CustomIconButton from './CustomIconButton';
import Input from '@mui/material/Input';
import InputAdornment from '@mui/material/InputAdornment';

/** 
    Custom Input
    takes in props
    @inputType - either text or select
    @multiline - if text input is multiline
    @optionList - options if select inputType
    @value - value displayed by the input
    @onChange - onChange handler
    @label - label (title) of the input
    @labelSize - 1-12 how much of the width is the label vs the input
    @color - default is primary <-blue could choose secondary (ie red)
    @icon - icon if there is an icon
    @onIconClick - when icon is clicked
    @onKeyDown - keyboard event handler for navigation (new prop)
    @inputRef - ref for focus management (new prop)
    @dataPanelType - identifies which panel this input belongs to (new prop)
**/

const CustomInput = forwardRef((props, ref) => {
    const handlerNumberChange = (event) => {
        if(event.target.value.toString().length > props.inputLength){
          let temp = event.target.value.toString().substring(0, props.inputLength);
          event.target.value = temp;          
        }  
    }
    
    // Handle key down events and pass them up to parent components
    const handleKeyDown = (e) => {
        if (props.onKeyDown) {
            props.onKeyDown(e);
        }
    };

    function renderInput() {
        // Common props to pass down to input components
        const inputProps = {
            ...props,
            onKeyDown: handleKeyDown,
            inputRef: ref || props.inputRef,
            'data-panel-type': props.dataPanelType
        };

        if (props.inputType === "select") {
            return (
                <SelectInput
                    optionList = {props.optionList}
                    value = {props.value}
                    onChange = {props.onChange}
                    label = {props.label}
                    labelSize={props.labelSize}
                    color={props.color}
                    {...inputProps}
                />
            );
        }
        if (props.inputType === "text" && props.multiline) {
            return (
                <TextInput
                    multiline
                    minRows={4}
                    id = {props.name}
                    type={props.type}
                    label={props.label}
                    labelSize={props.labelSize}
                    inputProps={{ maxLength: props.inputLength }}                    
                    variant="outlined"
                    size="large"
                    color={props.color}
                    onChange = {props.onChange}
                    {...inputProps}
                />
            );
        }

        if (props.inputType === "text") {
            return (
                <TextInput
                    type={props.type}
                    label={props.label}
                    id={props.name}
                    labelSize={props.labelSize}
                    inputProps={{ maxLength: props.inputLength }}
                    defaultValue={props.defaultValue}
                    variant="outlined"
                    size="small"
                    color={props.color}
                    onChange = {props.onChange}
                    {...inputProps}
                />
            );
        }

        if (props.inputType === "number") {
            return (
                <TextInput
                    type={props.type}
                    label={props.label}
                    id={props.name}
                    labelSize={props.labelSize}
                    defaultValue={props.defaultValue}
                    variant="outlined"
                    size="small"
                    color={props.color}
                    onChange = {handlerNumberChange}
                    {...inputProps}
                />  
            );
        }
    }

    return (
        <div>          
            <Grid
                container
                direction="row"
                //justifyContent='flex-end'
                justifyContent='stretch'
                style={{margin:'0', width:'100%' }}
                alignItems="stretch"
                spacing={0}
                sm={12}
                >
                <Grid item sm={10}>
                    {renderInput()}
                </Grid>
                <Grid item sm={2} style={{ display: 'flex', gap: '2px' }}>
                    {props.extraButton}
                    {props.icon && <CustomIconButton
                        icon={props.icon}
                        tooltip={props.iconTooltip}
                        onClick={props.onIconClick}
                        color={props.color}/>}
                </Grid>
            </Grid>
        </div>
    );
});

export default CustomInput;